export default __webpack_public_path__ + "static/media/successface.87fde45f.svg";